export default "__VITE_ASSET__BdL2C30X__"